import { CSSProperties } from 'react'
import { useIsInIframe, useBreakpoint } from '~/hooks'
import styled from 'styled-components'
import WaterMarkDesktopLight from '~/assets/images/powered-by-tokenlon-desktop-light.png'
import WaterMarkDesktopDark from '~/assets/images/powered-by-tokenlon-desktop-dark.png'
import WaterMarkMobileLight from '~/assets/images/powered-by-tokenlon-mobile-light.png'
import WaterMarkMobileDark from '~/assets/images/powered-by-tokenlon-mobile-dark.png'
import { useThemeName, isDarkThemeName } from '~/theme'

const StyledWaterMarkContainer = styled.div`
  ${({ theme }) => theme.media.sm`
    order: 2;
  `}
`

const StyledWaterMark = styled.img`
  margin: 0 auto;
  padding: 0;
  display: block;
  max-width: 120px;
`

const WaterMark: React.FC<{ style?: CSSProperties }> = ({ style }) => {
  const isInIframe = useIsInIframe()
  const { isMobile } = useBreakpoint()
  const themeName = useThemeName()
  const isDarkTheme = isDarkThemeName(themeName)
  const waterMarkSrc = isMobile
    ? isDarkTheme
      ? WaterMarkMobileDark.src
      : WaterMarkMobileLight.src
    : isDarkTheme
      ? WaterMarkDesktopDark.src
      : WaterMarkDesktopLight.src

  if (!isInIframe) return null

  return (
    <StyledWaterMarkContainer style={style}>
      <StyledWaterMark src={waterMarkSrc} />
    </StyledWaterMarkContainer>
  )
}

export default WaterMark
